import { ModelBase } from "Core/Models";
import { action, observable } from "mobx";

export class ReservationType1FinancialAdditionalIncentivesModel extends ModelBase<
    ReservationType1FinancialAdditionalIncentivesModel,
    ReservationType1FinancialAdditionalIncentivesDTO
> {
    //#region Properties
    @observable
    public id: string | undefined = "";

    @observable
    public reservationType1FinancialId: string | undefined = undefined;

    @observable
    public incentive: string | undefined = undefined;

    @observable
    public otherDetails: string = "";

    @observable
    public amount: string | undefined = undefined;
    //#endregion roperties

    @action
    public fromDto = (reservationDto: ReservationType1FinancialAdditionalIncentivesDTO) => {
        this.id = reservationDto.id;
        this.reservationType1FinancialId = reservationDto.reservationType1FinancialId;
        this.incentive = reservationDto.incentive;
        this.otherDetails = reservationDto.otherDetails;
        this.amount = reservationDto.amount;
    };

    public toDto = (): ReservationType1FinancialAdditionalIncentivesDTO => {
        return {
            id: this.id,
            reservationType1FinancialId: this.reservationType1FinancialId,
            incentive: this.incentive,
            otherDetails: this.otherDetails,
            amount: this.amount,
        };
    };
}
export interface ReservationType1FinancialAdditionalIncentivesDTO {
    id: string | undefined;
    reservationType1FinancialId?: string;
    incentive: string | undefined;
    otherDetails: string;
    amount: string | undefined;
}
